<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M102.5 39.92C98.96 37.67 94.26 38.71 92 42.25L87.36 49.53V16.75C87.36 12.55 83.95 9.14 79.75 9.14C77.36 9.14 75.22 10.25 73.83 11.98C72.76 9.07 69.98 7 66.7 7C63.42 7 60.64 9.08 59.57 11.98C58.18 10.25 56.04 9.14 53.65 9.14C49.45 9.14 46.04 12.55 46.04 16.75V22.72C45.92 22.72 45.81 22.7 45.69 22.7C42.02 22.7 39.05 25.67 39.05 29.33V66.77C39.03 67.1 39 67.44 39 67.78V71.13C39 76.92 41.88 82.02 46.27 85.13V112.22H80.27V86.02C82.26 84.8 83.95 83.13 85.2 81.16C85.35 80.97 85.49 80.78 85.62 80.58L104.84 50.42C107.1 46.88 106.06 42.17 102.51 39.92H102.5Z"
      fill="#CB80DE"
    />
    <path
      d="M87.54 114.71V108.43C87.54 105.26 84.9702 102.69 81.8 102.69H44.75C41.5799 102.69 39.01 105.26 39.01 108.43V114.71C39.01 117.88 41.5799 120.45 44.75 120.45H81.8C84.9702 120.45 87.54 117.88 87.54 114.71Z"
    />
    <path
      d="M87.35 49.73V49.53V30.91L39.05 36.73V60.58L84.78 54.19L87.35 49.73Z"
    />
    <path
      d="M39.05 66.78C39.03 67.11 39 67.44 39 67.78V71.13C39 76.92 41.88 82.02 46.27 85.13V91.65L80.27 95.7V86.02C82.34 84.75 84.07 83.01 85.33 80.93C85.42 80.81 85.53 80.7 85.61 80.57L90.74 72.52L39.05 65.13V66.77V66.78Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'AccidentInsurance'
  }
</script>
